// extracted by mini-css-extract-plugin
export default {"registrationForm":"iQ8qpmLn","title":"cY3xy9vF","description":"MwtdpEp9"};